import { Injectable } from '@angular/core'

import { ChallengeResponse } from './auth.types'

const CHALLENGE_STORAGE_KEY = 'yoshu_password_challenge'

@Injectable({ providedIn: 'root' })
export class ChallengeStorageService {
  storeChallenge(challenge: ChallengeResponse): void {
    sessionStorage.setItem(CHALLENGE_STORAGE_KEY, JSON.stringify(challenge))
  }

  getChallenge(): ChallengeResponse | null {
    const stored = sessionStorage.getItem(CHALLENGE_STORAGE_KEY)
    if (!stored) return null

    try {
      return JSON.parse(stored) as ChallengeResponse
    } catch {
      return null
    }
  }

  clearChallenge(): void {
    sessionStorage.removeItem(CHALLENGE_STORAGE_KEY)
  }

  hasChallenge(): boolean {
    return this.getChallenge() !== null
  }
}
